import React, { useEffect, useRef, useState, useContext, useMemo } from "react";
import Button from "../ui/button/Button";
import { IEmissionClass, IEngineType, IVehicleInfo, Vehicle, VehicleCategory, VehiclePost } from "../../types/vehicles";
import Slider from "../ui/slider/Slider";
import { useTranslation } from "react-i18next";
import { FleetContext } from "../../context/fleetContext";
import { IFleetContext } from "../../types/fleet";
import { fleetService } from "../../api/fleetService/fleetService";
import { toast } from "react-toastify";
interface ISidebarProps {
    isOpen?: boolean;
    callbackCloseSidebar: () => void;
    vehiclesInfo: IVehicleInfo[] | null
}

type section = 'engineType' | 'emissionClass'

const SidebarModifyFleet: React.FC<ISidebarProps> = ({
    isOpen = false,
    callbackCloseSidebar,
    vehiclesInfo
}) => {
    try {
        console.log('SidebarModifyFleet - Component rendered');
        console.log('SidebarModifyFleet - isOpen:', isOpen);
        console.log('SidebarModifyFleet - vehiclesInfo prop:', vehiclesInfo);
    } catch (error) {
        console.error('SidebarModifyFleet - Error in component:', error);
    }

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);

    // Context data
    const {
        vehicles,
        setVehicles,
        emissionClass,
        setEmissionClass,
        engineType,
        setEngineType,
        isIntermodal,
        setLastUpdate
    } = useContext(FleetContext) as IFleetContext;

    const [vehiclesComputed, setVehiclesComputed] = useState<VehicleCategory[]>([]);
    const [emissionClassComputed, setEmissionClassComputed] = useState<IEmissionClass[]>([]);
    const [engineTypeComputed, setEngineTypeComputed] = useState<IEngineType[]>([]);

    useEffect(() => {
        console.log('SidebarModifyFleet - useEffect triggered');
        console.log('SidebarModifyFleet - vehiclesInfo:', vehiclesInfo);
        console.log('SidebarModifyFleet - vehicles:', vehicles);
        console.log('SidebarModifyFleet - emissionClass:', emissionClass);
        console.log('SidebarModifyFleet - engineType:', engineType);
        
        if (!!vehicles) {
            setVehiclesComputed(groupVehicles(JSON.parse(JSON.stringify(vehicles))));
        }

        if (emissionClass.length > 0) {
            setEmissionClassComputed(JSON.parse(JSON.stringify(emissionClass)));
        }

        if (engineType.length > 0) {
            setEngineTypeComputed(JSON.parse(JSON.stringify(engineType)));
        }
    }, [vehicles, emissionClass, engineType, vehiclesInfo]);

    const groupVehicles: (vehicles: Vehicle[]) => VehicleCategory[] = (vehicles) => {
        let vehiclesArray: VehicleCategory[] = [];
        
        // Se vehiclesInfo è vuoto, mostra un messaggio di errore
        if (!vehiclesInfo || vehiclesInfo.length === 0) {
            console.warn('vehiclesInfo is empty or null in SidebarModifyFleet');
            return [];
        }
        
        vehiclesInfo.forEach(vehicleInfo => {
            const vehicleRecord = vehicles.find(v => v.vehicleId === vehicleInfo.id);
            if (!vehiclesArray.find(v => v.type === vehicleInfo['type'])) {
                vehiclesArray.push({
                    type: vehicleInfo['type'],
                    vehicles: [{
                        ...vehicleInfo,
                        quantity: !!vehicleRecord ? vehicleRecord.quantity : 0,
                        vehicleId: vehicleInfo.id,
                        id: !!vehicleRecord ? vehicleRecord.id : null
                    }]
                });
            } else {
                const index = vehiclesArray.findIndex(v => v.type === vehicleInfo['type']);
                vehiclesArray[index].vehicles.push({
                    ...vehicleInfo,
                    quantity: !!vehicleRecord ? vehicleRecord.quantity : 0,
                    vehicleId: vehicleInfo.id,
                    id: !!vehicleRecord ? vehicleRecord.id : null,
                });
            }
        });

        return vehiclesArray;
    }

    const modifyFleet = async () => {
        if (isIntermodal === false) {
            const vehiclesToAdd: Vehicle[] = [];

            vehiclesComputed.forEach((vehicleCategory) => {
                vehicleCategory.vehicles.forEach(vehicle => {
                    if (!(vehicle.id === null && vehicle.quantity === 0)) {
                        vehiclesToAdd.push({
                            id: vehicle.id,
                            quantity: vehicle.quantity,
                            vehicleId: vehicle.vehicleId
                        });
                    }
                })
            });

            let countEmissionClass = 0;
            let countEngineType = 0;
            let countDieselType = 0;
            emissionClassComputed.forEach(eC => countEmissionClass += eC.percentage);
            engineTypeComputed.forEach(eT => {
                countEngineType += eT.percentage;
                if (eT.field === "arcese_diesel") {
                    countDieselType += eT.percentage;
                }
            });

            if (countVehicles === 0) {
                return toast.error(t('common.errors.zeroVehicles'));
            }

            if (countEngineType !== 100) {
                return toast.error(t('common.errors.engineTypePercent'));
            }

            if (countDieselType > 0 && countEmissionClass !== 100) {
                return toast.error(t('common.errors.emissionClassPercent'));
            }

            const data = {
                engineType: engineTypeComputed,
                emissionClass: (countDieselType === 0 && countEmissionClass > 0) ? [...emissionClassComputed].map(eC => {
                    return {
                        ...eC,
                        percentage: 0
                    }
                }) : emissionClassComputed,
                fleet: vehiclesToAdd
            }

            setLoading(true);
            const response = await fleetService.postFleet(data);
            if (response.success) {
                // Get & set fleet again
                const responseGetFleet = await fleetService.getFleet();
                if (responseGetFleet.success) {
                    setEmissionClass(responseGetFleet.responseBody.emissionClass);
                    setEngineType(responseGetFleet.responseBody.engineType);
                    setVehicles(responseGetFleet.responseBody.fleet);
                    setLastUpdate(responseGetFleet.responseBody.lastUpdate);
                    callbackCloseSidebar();
                } else {
                    window.location.reload();
                }
            } else {
                console.log('error modify fleet')
            }

            setLoading(false);
        }
    }

    const addVehicle = (vehicleCategoryIndex: number, vehicleId: string) => () => {
        const vehiclesCopy = [...vehiclesComputed];
        const vehicleIndex = vehiclesCopy[vehicleCategoryIndex].vehicles.findIndex(vehicle => vehicle.vehicleId === vehicleId);
        if (vehicleIndex !== -1) {
            vehiclesCopy[vehicleCategoryIndex].vehicles[vehicleIndex].quantity = parseInt(vehiclesCopy[vehicleCategoryIndex].vehicles[vehicleIndex].quantity.toString()) + 1;
            setVehiclesComputed([...vehiclesCopy]);
        }
    }

    const removeVehicle = (vehicleCategoryIndex: number, vehicleId: string) => () => {
        const vehiclesCopy = [...vehiclesComputed];
        const vehicleIndex = vehiclesCopy[vehicleCategoryIndex].vehicles.findIndex(vehicle => vehicle.vehicleId === vehicleId);

        if (vehicleIndex !== -1) {
            if (vehiclesCopy[vehicleCategoryIndex].vehicles[vehicleIndex].quantity !== "" && parseInt(vehiclesCopy[vehicleCategoryIndex].vehicles[vehicleIndex].quantity.toString()) > 0) {
                vehiclesCopy[vehicleCategoryIndex].vehicles[vehicleIndex].quantity = parseInt(vehiclesCopy[vehicleCategoryIndex].vehicles[vehicleIndex].quantity.toString()) - 1;
                setVehiclesComputed(vehiclesCopy);
            }
        }
    }

    const onChangeVehicleQuantity = (e: any, vehicleCategoryIndex: number, vehicleId: string) => {
        const vehiclesCopy = [...vehiclesComputed];
        const vehicleIndex = vehiclesCopy[vehicleCategoryIndex].vehicles.findIndex(vehicle => vehicle.vehicleId === vehicleId);
        if (vehicleIndex !== -1 && (e.target.value === '' || (!isNaN(parseInt(e.target.value)) && e.target.value >= 0))) {
            vehiclesCopy[vehicleCategoryIndex].vehicles[vehicleIndex].quantity = e.target.value;
            setVehiclesComputed(vehiclesCopy);
        }
    }

    const onBlurVehicleQuantity = (vehicleCategoryIndex: number, vehicleId: string) => () => {
        const vehiclesCopy = [...vehiclesComputed];
        const vehicleIndex = vehiclesCopy[vehicleCategoryIndex].vehicles.findIndex(vehicle => vehicle.vehicleId === vehicleId);
        if (vehicleIndex !== -1 && vehiclesCopy[vehicleCategoryIndex].vehicles[vehicleIndex].quantity === '') {
            vehiclesCopy[vehicleCategoryIndex].vehicles[vehicleIndex].quantity = 0;
            setVehiclesComputed(vehiclesCopy);
        } else if (!isNaN(parseInt(vehiclesCopy[vehicleCategoryIndex].vehicles[vehicleIndex].quantity.toString()))) {
            vehiclesCopy[vehicleCategoryIndex].vehicles[vehicleIndex].quantity = parseInt(vehiclesCopy[vehicleCategoryIndex].vehicles[vehicleIndex].quantity.toString());
            setVehiclesComputed(vehiclesCopy);
        }
    }

    const handleIncrease = (section: section, field: string) => {
        const array = section === "emissionClass" ? [...emissionClassComputed] : [...engineTypeComputed];
        const index = array.findIndex(item => item.field === field);

        if (index !== -1 && array[index].percentage <= 95) {
            array[index].percentage += 5;
        } else {
            array[index].percentage = 100;
        }

        if (section === 'emissionClass') {
            setEmissionClassComputed(array);
        } else if (section === 'engineType') {
            setEngineTypeComputed(array);
        }
    };

    const handleDecrease = (section: section, field: string) => {
        const array = section === "emissionClass" ? [...emissionClassComputed] : [...engineTypeComputed];
        const index = array.findIndex(item => item.field === field);

        if (index !== -1 && array[index].percentage >= 5) {
            array[index].percentage -= 5;
        } else {
            array[index].percentage = 0;
        }

        if (section === 'emissionClass') {
            setEmissionClassComputed(array);
        } else if (section === 'engineType') {
            setEngineTypeComputed(array);
        }
    };

    const handleMove = (percent: number, section: section, field: string) => {
        const array = section === "emissionClass" ? [...emissionClassComputed] : [...engineTypeComputed];
        const index = array.findIndex(item => item.field === field);

        if (index !== -1 && percent % 5 === 0) {
            array[index].percentage = percent;
        }

        if (section === 'emissionClass') {
            setEmissionClassComputed(array);
        } else if (section === 'engineType') {
            setEngineTypeComputed(array);
        }
    };

    const isThereAtLeastOneDiesel = useMemo(() => {
        let can = false;
        for (let index = 0; index < engineTypeComputed.length; index++) {
            const element = engineTypeComputed[index];
            if (element.field === "arcese_diesel" && element.percentage > 0) {
                can = true;
                break;
            }
        }

        return can;
    }, [engineTypeComputed]);

    const countVehicles = useMemo(() => {
        let count = 0;
        vehiclesComputed.forEach(vehicleCategory => {
            if (vehicleCategory.type !== "Semirimorchi" && vehicleCategory.type !== "Trailers") {
                vehicleCategory.vehicles.forEach(v => {
                    count = count + parseInt(v.quantity.toString());
                })
            }
        });

        if (!isNaN(count)) {
            return count;
        }

        return 0;
    }, [vehiclesComputed]);

    try {
        console.log('SidebarModifyFleet - Rendering sidebar, isOpen:', isOpen);
        
        return (
            <aside
                className={"flex flex-col transition z-10 fixed right-0 top-0 h-[100dvh] w-screen md:w-[520px] bg-white overflow-auto hide-scrollbar" + (isOpen === true ? " translate-x-0 sidebar-shadow" : " translate-x-[100%]")}
            >
            <div className="shrink-0 h-[88px] px-[30px] pt-[32px] pb-[24px] border-b flex justify-between items-center">
                <div className="text-lg font-bold leading-[21.6px]">
                    {t('common.sidebars.modifyFleet.heading')}
                </div>
                <div onClick={callbackCloseSidebar} className="cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-8 h-8">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
            </div>

            {/* MAIN CONTENT OF SIDEBAR */}
            <div className="grow overflow-auto px-[30px] py-8">
                {vehiclesComputed.length === 0 ? (
                    <div className="text-center py-8">
                        <p className="text-gray-500 mb-4">
                            {!vehiclesInfo || vehiclesInfo.length === 0 
                                ? "Caricamento dati veicoli..." 
                                : "Nessun veicolo disponibile"}
                        </p>
                        {(!vehiclesInfo || vehiclesInfo.length === 0) && (
                            <p className="text-sm text-gray-400">
                                Verificare che i dati della flotta siano stati caricati correttamente
                            </p>
                        )}
                    </div>
                ) : (
                    vehiclesComputed.map((vehicleCategory, index) => {
                        return (
                            <div className="mb-10" key={index}>
                                <h4 className="select-none font-bold text-lg leading-[21.6px] mb-5">{vehicleCategory.type}</h4>
                                <div>
                                    {
                                        vehicleCategory.vehicles.map((vehicle, i) => {
                                            return (
                                                <div key={i} className="flex items-center mb-5">
                                                    <div className="flex items-center mr-5">
                                                        {/* MINUS */}
                                                        <div onClick={removeVehicle(index, vehicle.vehicleId)} className="cursor-pointer">
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4 stroke-red">
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15" />
                                                            </svg>
                                                        </div>
                                                        {/* QUANTITY */}
                                                        <div className="text-[13px] mx-[10px] h-6 w-6 flex items-center justify-center border border-[#6F6F6F]">
                                                            <input
                                                                className="w-full h-full text-center leading-full"
                                                                type="text"
                                                                inputMode="numeric"
                                                                value={vehicle.quantity}
                                                                onChange={(e) => onChangeVehicleQuantity(e, index, vehicle.vehicleId)}
                                                                onBlur={onBlurVehicleQuantity(index, vehicle.vehicleId)}
                                                            />
                                                        </div>
                                                        {/* PLUS */}
                                                        <div onClick={addVehicle(index, vehicle.vehicleId)} className="cursor-pointer">
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} className="w-4 h-4 stroke-red">
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center select-none">
                                                        <div dangerouslySetInnerHTML={{ __html: vehicle.icon }} />
                                                        <div className="text-[15px] ml-[10px] leading-[18px]">{vehicle.name}</div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        )
                    })
                )}

                {/* ENGINE TYPES */}
                <div className="mb-[44px]">
                    <h4 className="select-none font-bold text-lg leading-[21.6px] mb-2">{t('common.sidebars.modifyFleet.subParts.typeOfEngine.heading')}</h4>
                    <p dangerouslySetInnerHTML={{ __html: t('common.sidebars.modifyFleet.subParts.typeOfEngine.paragraph', { count_vehicles: countVehicles }).toString() }} className="text-[15px] leading-[18px] mb-5"></p>
                    {
                        engineTypeComputed.map((type, index) => {
                            return (
                                <div key={index} className="mb-[44px]">
                                    <Slider
                                        percentage={type.percentage}
                                        label={type.name}
                                        callbackIncrease={() => handleIncrease('engineType', type.field)}
                                        callbackDecrease={() => handleDecrease('engineType', type.field)}
                                        callbackMove={(percent) => handleMove(percent, 'engineType', type.field)}
                                    />
                                </div>
                            )
                        })
                    }
                </div>

                {/* EMISSION CLASS */}
                {
                    isThereAtLeastOneDiesel === true &&
                    <div className="mb-[44px]">
                        <h4 className="select-none font-bold text-lg leading-[21.6px] mb-2">{t('common.sidebars.modifyFleet.subParts.emissionClass.heading')}</h4>
                        <p className="text-[15px] leading-[18px] mb-5">
                            {t('common.sidebars.modifyFleet.subParts.emissionClass.paragraph')}
                        </p>

                        {
                            emissionClassComputed.map((type, index) => {
                                return (
                                    <div key={index} className="mb-[44px]">
                                        <Slider
                                            percentage={type.percentage}
                                            label={type.name}
                                            callbackIncrease={() => handleIncrease('emissionClass', type.field)}
                                            callbackDecrease={() => handleDecrease('emissionClass', type.field)}
                                            callbackMove={(percent) => handleMove(percent, 'emissionClass', type.field)}
                                        />
                                    </div>
                                )
                            })
                        }
                    </div>
                }
            </div>

            <div className="shrink-0 py-6 px-[30px] text-right border-t">
                <Button
                    callback={modifyFleet}
                    loading={loading}
                >
                    {t('common.sidebars.saveButtonText')}
                </Button>
            </div>
        </aside>
        );
    } catch (error) {
        console.error('SidebarModifyFleet - Error during render:', error);
        return (
            <aside className="flex flex-col transition z-10 fixed right-0 top-0 h-[100dvh] w-screen md:w-[520px] bg-white overflow-auto hide-scrollbar translate-x-0 sidebar-shadow">
                <div className="shrink-0 h-[88px] px-[30px] pt-[32px] pb-[24px] border-b flex justify-between items-center">
                    <div className="text-lg font-bold leading-[21.6px]">
                        Errore
                    </div>
                    <div onClick={callbackCloseSidebar} className="cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-8 h-8">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </div>
                </div>
                <div className="grow overflow-auto px-[30px] py-8">
                    <div className="text-center py-8">
                        <p className="text-red-500 mb-4">
                            Errore durante il caricamento della sidebar
                        </p>
                        <p className="text-sm text-gray-400">
                            {error?.toString()}
                        </p>
                    </div>
                </div>
            </aside>
        );
    }
};

export default React.memo(SidebarModifyFleet);